// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   updatePassword,
//   updatePin,
//   clearStatus,
//   fetchAdminProfile,
// } from "../redux/slices/profileSlice";
// import "../assets/SuperAdminProfile.css";

// const SuperAdminProfile = () => {
//   const dispatch = useDispatch();
//   const { loading, success, error, profileData } = useSelector((state) => state.profile);

//   const [profileImage, setProfileImage] = useState(localStorage.getItem("profileImage") || "");
//   const [oldPassword, setOldPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [oldPin, setOldPin] = useState("");
//   const [newPin, setNewPin] = useState("");

//   useEffect(() => {
//     dispatch(fetchAdminProfile());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success || error) {
//       const timeout = setTimeout(() => dispatch(clearStatus()), 3000);
//       return () => clearTimeout(timeout);
//     }
//   }, [success, error, dispatch]);

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfileImage(reader.result);
//         localStorage.setItem("profileImage", reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handlePasswordUpdate = () => {
//     if (!oldPassword.trim() || !newPassword.trim()) {
//       alert("Please enter both old and new password.");
//       return;
//     }
//     dispatch(updatePassword({ oldPassword, newPassword }));
//     setOldPassword("");
//     setNewPassword("");
//   };

//   const handlePinUpdate = () => {
//     if (!/^\d{4,6}$/.test(oldPin) || !/^\d{4,6}$/.test(newPin)) {
//       alert("PIN must be 4 to 6 digits.");
//       return;
//     }
//     dispatch(updatePin({ oldPin, newPin }));
//     setOldPin("");
//     setNewPin("");
//   };

//   return (
//     <div className="SuperAdminProfile-container">
//       <div className="SuperAdminProfile-card">
//         <div className="SuperAdminProfile-header">
//           <div className="SuperAdminProfile-img-wrapper">
//             <img
//               src={profileImage || "https://ui-avatars.com/api/?name=Super+Admin"}
//               alt="Profile"
//               className="SuperAdminProfile-image"
//             />
//             <label htmlFor="profileUpload" className="SuperAdminProfile-uploadBtn">
//               Upload Image
//             </label>
//             <input
//               type="file"
//               id="profileUpload"
//               accept="image/*"
//               onChange={handleImageUpload}
//               hidden
//             />
//           </div>

//           <div className="SuperAdminProfile-userInfo">
//             <h2>{profileData?.name || "Super Admin"}</h2>
//             <span className="badge">{profileData?.role}</span>
//           </div>
//         </div>

//         <div className="SuperAdminProfile-section">
//           <h3>👤 Account Information</h3>
//           <div className="SuperAdminProfile-grid">
//             {[
//               { label: "Name", value: profileData?.name, color: "#111827" },
//               { label: "Email", value: profileData?.email, color: "#065f46" },
//               { label: "Role", value: profileData?.role, color: "#1d4ed8" },
//               { label: "Mobile", value: profileData?.mobile, color: "#9d174d" },
//               { label: "Guardian", value: profileData?.guardian, color: "#7c3aed" },
//             ].map(({ label, value, color }) => (
//               <div key={label} className="info-box">
//                 <label>{label}</label>
//                 <p style={{ color }}><strong>{value}</strong></p>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="SuperAdminProfile-section">
//           <h3>🔐 Update Password</h3>
//           <div className="SuperAdminProfile-grid">
//             <div>
//               <label>Old Password</label>
//               <input
//                 type="password"
//                 className="SuperAdminProfile-input"
//                 value={oldPassword}
//                 onChange={(e) => setOldPassword(e.target.value)}
//               />
//               <label>New Password</label>
//               <input
//                 type="password"
//                 className="SuperAdminProfile-input"
//                 value={newPassword}
//                 onChange={(e) => setNewPassword(e.target.value)}
//               />
//               <button
//                 className="SuperAdminProfile-btn"
//                 onClick={handlePasswordUpdate}
//                 disabled={loading}
//               >
//                 {loading ? "Updating..." : "Update Password"}
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="SuperAdminProfile-section">
//           <h3>🔢 Update PIN</h3>
//           <div className="SuperAdminProfile-grid">
//             <div>
//               <label>Old PIN</label>
//               <input
//                 type="password"
//                 className="SuperAdminProfile-input"
//                 value={oldPin}
//                 onChange={(e) => setOldPin(e.target.value)}
//               />
//               <label>New PIN</label>
//               <input
//                 type="password"
//                 className="SuperAdminProfile-input"
//                 value={newPin}
//                 onChange={(e) => setNewPin(e.target.value)}
//               />
//               <button
//                 className="SuperAdminProfile-btn"
//                 onClick={handlePinUpdate}
//                 disabled={loading}
//               >
//                 {loading ? "Updating..." : "Update PIN"}
//               </button>
//             </div>
//           </div>
//         </div>

//         {(success || error) && (
//           <div className={`SuperAdminProfile-status ${success ? "SuperAdminProfile-success" : "SuperAdminProfile-error"}`}>
//             {success || error}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SuperAdminProfile;


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updatePassword,
  updatePin,
  clearStatus,
  fetchAdminProfile,
} from "../redux/slices/profileSlice";
import "../assets/SuperAdminProfile.css";

const SuperAdminProfile = () => {
  const dispatch = useDispatch();
  const { loading, success, error, profileData } = useSelector(
    (state) => state.profile
  );

  const [profileImage, setProfileImage] = useState(
    localStorage.getItem("profileImage") || ""
  );
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [oldPin, setOldPin] = useState("");
  const [newPin, setNewPin] = useState("");

  useEffect(() => {
    dispatch(fetchAdminProfile());
  }, [dispatch]);

  useEffect(() => {
    if (success || error) {
      const timeout = setTimeout(() => dispatch(clearStatus()), 3000);
      return () => clearTimeout(timeout);
    }
  }, [success, error, dispatch]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
        localStorage.setItem("profileImage", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePasswordUpdate = () => {
    if (!oldPassword.trim() || !newPassword.trim()) {
      alert("Please enter both old and new password.");
      return;
    }
    dispatch(updatePassword({ oldPassword, newPassword }));
    setOldPassword("");
    setNewPassword("");
  };

  const handlePinUpdate = () => {
    if (!/^\d{4,6}$/.test(oldPin) || !/^\d{4,6}$/.test(newPin)) {
      alert("PIN must be 4 to 6 digits.");
      return;
    }
    dispatch(updatePin({ oldPin, newPin }));
    setOldPin("");
    setNewPin("");
  };

  return (
    <div className="SuperAdminProfile-container">
      <div className="SuperAdminProfile-card">

        {/* Header: Profile Image + Name */}
        <div className="SuperAdminProfile-header">
          <div className="SuperAdminProfile-img-wrapper">
            <img
              src={profileImage || "https://ui-avatars.com/api/?name=Super+Admin"}
              alt="Profile"
              className="SuperAdminProfile-image"
            />
            <label htmlFor="profileUpload" className="SuperAdminProfile-uploadBtn">
              Upload Image
            </label>
            <input
              type="file"
              id="profileUpload"
              accept="image/*"
              onChange={handleImageUpload}
              hidden
            />
          </div>

          <div className="SuperAdminProfile-userInfo">
            <h2>{profileData?.name || "Super Admin"} <span className="profile-static-text">(Director)</span></h2>
            <span className="badge">{profileData?.role}</span>
          </div>
        </div>

        {/* Account Info Table */}
        <div className="SuperAdminProfile-section">
          <h3>👤 Account Information</h3>
          <div className="SuperAdminProfile-table">
            {[
              { label: "Name", value: profileData?.name },
              { label: "Email", value: profileData?.email },
              { label: "Role", value: profileData?.role },
              { label: "Mobile", value: profileData?.mobile },
              { label: "Guardian", value: profileData?.guardian },
            ].map(({ label, value }) => (
              <div key={label} className="SuperAdminProfile-row">
                <span className="SuperAdminProfile-label">{label}</span>
                <span className="SuperAdminProfile-value">{value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="SuperAdminProfile-card" style={{marginTop:"50px"}}>
        {/* Update Password */}
        <div className="SuperAdminProfile-section">
          <h3>🔐 Update Password</h3>
          <div className="SuperAdminProfile-grid">
            <div>
              <label>Old Password</label>
              <input
                type="password"
                className="SuperAdminProfile-input"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
              <label>New Password</label>
              <input
                type="password"
                className="SuperAdminProfile-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button
                className="SuperAdminProfile-btn"
                onClick={handlePasswordUpdate}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Password"}
              </button>
            </div>
          </div>
        </div>
      </div>
        

       <div className="SuperAdminProfile-card" style={{marginTop:"50px"}}>
         {/* Update PIN */}
        <div className="SuperAdminProfile-section">
          <h3>🔢 Update PIN</h3>
          <div className="SuperAdminProfile-grid">
            <div>
              <label>Old PIN</label>
              <input
                type="password"
                className="SuperAdminProfile-input"
                value={oldPin}
                onChange={(e) => setOldPin(e.target.value)}
              />
              <label>New PIN</label>
              <input
                type="password"
                className="SuperAdminProfile-input"
                value={newPin}
                onChange={(e) => setNewPin(e.target.value)}
              />
              <button
                className="SuperAdminProfile-btn"
                onClick={handlePinUpdate}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update PIN"}
              </button>
            </div>
          </div>
        </div>
       </div>

        {/* Status */}
        {(success || error) && (
          <div className={`SuperAdminProfile-status ${success ? "SuperAdminProfile-success" : "SuperAdminProfile-error"}`}>
            {success || error}
          </div>
        )}
      
    </div>
  );
};

export default SuperAdminProfile;